import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function greaterThanControlValidator (controlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const form = control.parent;
    if (!form) {
      return null;
    }

    const start = form.get(controlName).value,
     end = control.value;

    if (!start || !end || isNaN(start) || isNaN(end)) {
      return null;
    }

    if (+start <= +end) {
      return null;
    }

    return { "min": { "min": start } };
  };
}
